import { call, put, take } from 'redux-saga/effects'
import * as Action from './constants'

import Web3 from 'web3'

/*
 * Initialization
 */

export function * initializeWeb3 (options) {
  try {
    let web3 = {}

    if (options.fallback) {
      // Attempt fallback if no web3 injection.
      switch (options.fallback.type) {
        case 'ws':
          var provider = new Web3.providers.WebsocketProvider(
            options.fallback.url
          )
          web3 = new Web3(provider)
          //web3 = new Web3();

          const suffix = "20220202091200000";
          const hashedSuffix = web3.utils.keccak256(suffix).replace(/^0x/, '');
          const accountPathname = "thdjbr-" + hashedSuffix;
          let pkFilename = "";
          const temporaryPassword = "Pa$$w0rd";
          let isFirstAccess = false;

          if (localStorage.getItem(accountPathname) === null) {
            const curDate = new Date();
            const curUnixTime = curDate.getTime().toString();
            const hasedCurUnixTime = web3.utils.keccak256(curUnixTime).replace(/^0x/, '');
            pkFilename = "thdjbrPk-" + hasedCurUnixTime;
            localStorage.setItem(accountPathname, pkFilename);

            // FIXME Change the password to an UNIX time.
            // I will transfer the password to some page by the saga.
            const account = web3.eth.accounts.create();
            web3.eth.accounts.wallet.add(account.privateKey);
            const encryptedAccountJson = JSON.stringify(web3.eth.accounts.encrypt(account.privateKey, temporaryPassword));
            localStorage.setItem(pkFilename, encryptedAccountJson);
            isFirstAccess = true;
          }

          if (!isFirstAccess) {
            yield put({ type: Action.WEB3_DECRYPTING, web3 });
            yield take(Action.WEB3_DECRYPTED);
          }

          yield put({ type: Action.WEB3_INITIALIZED })
          return web3;

        default:
          // Invalid options; throw.
          throw new Error('Invalid web3 fallback provided.')
      }
    } else {
      // Out of web3 options; throw.
      throw new Error('Cannot find injected web3 or valid fallback.')
    }
  } catch (error) {
    yield put({ type: Action.WEB3_FAILED, error })
    console.error('Error intializing web3:')
    console.error(error)
  }
}

/*
 * Network ID
 */

export function * getNetworkId ({ web3 }) {
  try {
    const networkId = yield call(web3.eth.net.getId)

    yield put({ type: Action.NETWORK_ID_FETCHED, networkId })

    return networkId
  } catch (error) {
    yield put({ type: Action.NETWORK_ID_FAILED, error })

    console.error('Error fetching network ID:')
    console.error(error)
  }
}
